import d from "../../node_modules/classnames/index.js";
import { jsx as i } from "../../_virtual/jsx-runtime.js";
function m({
  className: f,
  size: r = "full",
  takeFullSizeMobile: e = !0,
  children: l
}) {
  return /* @__PURE__ */ i("div", {
    className: d("form-grid__field", {
      "form-grid__field--full": r === "full",
      "form-grid__field--half": r === "half",
      "form-grid__field--one-third": r === "one-third",
      "form-grid__field--quarter": r === "quarter",
      "form-grid__field--three-quarter": r === "three-quarter"
    }, f),
    "data-full-size-mobile": e,
    children: l
  });
}
export {
  m as FormField
};
//# sourceMappingURL=FormField.js.map
